import { motion } from "framer-motion";
import { Award, ShieldCheck, Stethoscope } from "lucide-react";

const PHOTO_PORTRAIT = "https://customer-assets.emergentagent.com/job_yago-aesthetic/artifacts/vbcj4yef_Bertuol-1.jpg";
const PHOTO_SBCP = "https://customer-assets.emergentagent.com/job_yago-aesthetic/artifacts/jetgxvnn_IMG_8274.jpg";

export const AboutSection = () => {
  return (
    <section
      id="sobre"
      data-testid="about-section"
      className="py-28 md:py-40 bg-white overflow-x-hidden"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          {/* Left - Images */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="relative"
          >
            <div className="aspect-[3/4] overflow-hidden">
              <img
                src={PHOTO_PORTRAIT}
                alt="Dr. Yago Almeida"
                className="w-full h-full object-cover object-top"
                data-testid="about-doctor-image"
              />
            </div>
            <div className="absolute -bottom-6 -right-3 md:-right-6 w-36 md:w-48 aspect-[4/3] overflow-hidden shadow-[0_8px_30px_rgba(1,30,72,0.12)] border-[3px] border-white">
              <img
                src={PHOTO_SBCP}
                alt="Dr. Yago Almeida — Congresso SBCP"
                className="w-full h-full object-cover object-center"
                data-testid="about-sbcp-image"
              />
            </div>
          </motion.div>

          {/* Right - Text */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.15 }}
          >
            <p className="font-body text-gold text-xs font-medium tracking-[0.35em] uppercase mb-4">
              Sobre o Doutor
            </p>
            <h2 className="font-heading text-navy text-4xl md:text-5xl font-medium leading-tight mb-6">
              Dr. Yago Almeida
            </h2>
            <div className="gold-line mb-8" />

            <p className="font-body text-navy/70 text-[15px] leading-[1.8] mb-5">
              Cirurgião plástico com foco em excelência técnica, atenção ao detalhe e planejamento individualizado. Cada procedimento é conduzido com respeito à anatomia, aos objetivos de cada paciente e à busca por resultados harmônicos e naturais.
            </p>

            <p className="font-body text-navy/70 text-[15px] leading-[1.8] mb-12">
              Membro da Sociedade Brasileira de Cirurgia Plástica, com dupla certificação em cirurgia geral e cirurgia plástica, dedica-se integralmente a procedimentos seguros, técnica refinada e recuperação otimizada com apoio de tecnologias de ponta.
            </p>

            {/* Credentials */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-8">
              <div className="flex items-start gap-3" data-testid="credential-crm">
                <ShieldCheck className="text-gold/80 mt-0.5 flex-shrink-0" size={20} />
                <div>
                  <p className="font-body text-navy font-semibold text-sm">CRM-RS 45316</p>
                  <p className="font-body text-navy/50 text-xs mt-1">Conselho Regional de Medicina</p>
                </div>
              </div>
              <div className="flex items-start gap-3" data-testid="credential-rqe-geral">
                <Stethoscope className="text-gold/80 mt-0.5 flex-shrink-0" size={20} />
                <div>
                  <p className="font-body text-navy font-semibold text-sm">RQE 41765</p>
                  <p className="font-body text-navy/50 text-xs mt-1">Cirurgia Geral</p>
                </div>
              </div>
              <div className="flex items-start gap-3" data-testid="credential-rqe-plastica">
                <Award className="text-gold/80 mt-0.5 flex-shrink-0" size={20} />
                <div>
                  <p className="font-body text-navy font-semibold text-sm">RQE 47594</p>
                  <p className="font-body text-navy/50 text-xs mt-1">Cirurgia Plástica</p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
